<template>
  <el-form ref="search" inline :model="search" size="mini">
    <el-form-item label=''>
      <el-date-picker
          v-model='month_range'
          type='monthrange'
          align='right'
          unlink-panels
          range-separator='至'
          start-placeholder='开始日期'
          end-placeholder='结束日期'
          value-format='yyyy-MM'
          format='yyyy年MM月'
          style="width: 220px" >
      </el-date-picker>
    </el-form-item>
    <el-form-item>
      <el-date-picker v-model="date_live"
                      type="month" value-format="yyyy-MM" format="yyyy年MM月"
                      placeholder="搜索月份" style="width: 130px"/>
    </el-form-item>
    <el-form-item>
      <select-artist :value.sync="search.artist_id" @change="handelSearch"/>
    </el-form-item>
    <el-form-item>
      <el-input v-model="search.shop_name" clearable placeholder="搜索店铺" @change="handelSearch"/>
    </el-form-item>
    <el-form-item>
      <el-input v-model="search.product_name" clearable placeholder="搜索商品" @change="handelSearch"/>
    </el-form-item>
    <el-form-item>
      <select-platform :value.sync="search.platform" @change="handelSearch"/>
    </el-form-item>
    <el-form-item>
      <el-select v-model="search.rebate_is_claim" placeholder="搜索状态" clearable @change="handelSearch">
        <el-option v-for="(item,value) in MapClaim" :key="value" :label="item.label" :value="value"/>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button icon="el-icon-search" type="primary" @click="handelSearch">查询</el-button>
    </el-form-item>
    <el-form-item>
      <slot name="downLoad"/>
    </el-form-item>
    <el-form-item style="float: right">
      <slot name="rebate"/>
    </el-form-item>
  </el-form>
</template>
<script>
import {MapClaim} from "../index";
import SelectArtist from "../../../../components/Selects/artist.vue";
import SelectPlatform from "../../../../components/Selects/platform.vue";
import moment from "moment";

export default {
  name: 'LiveGuaranteeSearch',
  components: {SelectPlatform, SelectArtist},
  data() {
    return {
      MapClaim,
      month_range: [],
      date_live: moment().subtract(1, 'month').format('YYYY-MM'),
      search: {
        date_check: null,
        shop_name: null,
        artist_id: null,
        product_name: null,
        source_traffic: null,
        order_no: null,
        status: null,
        date_live_rang: [],

      }
    }
  },
  // watch: {
  //   "search.date_live": {
  //     immediate: true,
  //     handler() {
  //       this.search.date_live_rang = null
  //       if (this.search.date_live) {
  //         this.search.date_live_rang = [
  //           moment(this.search.date_live).startOf('month').format('YYYY-MM-DD'),
  //           moment(this.search.date_live).endOf('month').format('YYYY-MM-DD'),
  //         ]
  //       }
  //       this.$emit('search')
  //     }
  //   }
  // },
  methods: {
    handelSearch: function () {
      this.$emit('search')
    },
    getSearch: function () {
      this.search.date_live_rang = []
      if (this.date_live) {
        this.search.date_live_rang = [
          moment(this.date_live).startOf('month').format('YYYY-MM-DD'),
          moment(this.date_live).endOf('month').format('YYYY-MM-DD'),
        ]
      }
      if (this.month_range && this.month_range.length === 2) {
        this.search.date_live_rang = [
          moment(this.month_range[0]).startOf('month').format('YYYY-MM-DD'),
          moment(this.month_range[1]).endOf('month').format('YYYY-MM-DD')
        ]
      }

      return {...{}, ...this.search}
    }
  }
}

</script>
<style>

</style>
